import { ActionTypes } from "../../../constants/ActionConstants";

const initialState = {
  openModal: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.TargetGroupForm.OPEN_TARGET_GROUP_MODAL:
      return {
        ...state,
        openModal: true,
      };
    case ActionTypes.TargetGroupForm.CLOSE_TARGET_GROUP_MODAL:
      return {
        ...state,
        openModal: false,
      };

    default:
      return state;
  }
};
